import { createReducer, on } from '@ngrx/store';

import {
  clearViewsState,
  closeAssignDriver,
  loadPricingSettingsSuccess,
  openAssignDriver,
  resetSelectedListTabs,
  setAssignDriverBooking,
  setProfile,
  setProfileImage,
  setSelectedListTab,
} from './views.actions';
import { INITIAL_VIEWS_STATE } from './views.state';

export const viewsReducer = createReducer(
  INITIAL_VIEWS_STATE,

  // profile
  on(setProfileImage, (state, { image }) => ({
    ...state,
    profileImage: image,
  })),

  on(setProfile, (state, { profile }) => ({
    ...state,
    profile: profile,
  })),

  // pricing settings
  on(loadPricingSettingsSuccess, (state, { settings }) => ({
    ...state,
    pricingSettings: settings,
  })),

  //toggle assign driver dialog on assign from booking management
  on(openAssignDriver, (state) => ({ ...state, isAssignDriverOpen: true })),
  on(closeAssignDriver, (state) => ({ ...state, isAssignDriverOpen: false })),
  on(setAssignDriverBooking, (state, { booking }) => ({
    ...state,
    assignDriverBooking: booking,
  })),

  // list tabs persistence
  on(setSelectedListTab, (state, { featureKey, tabKey }) => ({
    ...state,
    selectedListTabs: {
      ...(state.selectedListTabs || {}),
      [featureKey]: tabKey,
    },
  })),

  on(resetSelectedListTabs, (state) => ({
    ...state,
    selectedListTabs: {},
  })),

  // clear state but keep required info
  on(clearViewsState, (state) => ({
    ...INITIAL_VIEWS_STATE,
    profileImage: state.profileImage,
    profile: state.profile,
    pricingSettings: state.pricingSettings,
    selectedListTabs: state.selectedListTabs,
  }))
);
